import { signInWithPopup } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { Button, Grid } from "@mui/material";

import { auth, provider, db } from "@/firebase";
import { setToken } from "@/localStorage/utils";
import { pages } from "@/routes/constants";
import login from "@/assets/png/login.png";
import { ReactComponent as GoogleIcon } from "@/assets/svg/google-icon.svg";

export const Login = () => {
  const saveUser = async (user: {
    uid: string;
    email: string | null;
    displayName: string | null;
  }) => {
    if (!user.email) return;

    const displayName = user.displayName || "";
    await setDoc(
      doc(db, "users", user.uid),
      {
        email: user.email,
        name: displayName,
        name_lower: displayName.trim().toLowerCase(),
        createdAt: new Date().toISOString(),
      },
      { merge: true }
    );
  };

  const loginWithGoogle = async () => {
    try {
      const res = await signInWithPopup(auth, provider);
      const user = res.user;
      await saveUser(user);
      const token = await user.getIdToken();
      setToken(token);

      window.location.href = `/app/${pages.securityAwareness}`;
    } catch (error: unknown) {
      const { code, message } = error as Error & { code: string };
      if (code === "auth/unauthorized-domain") {
        console.error("Domain not authorized:", message);
        return;
      }
      console.error("Login error:", error);
    }
  };

  return (
    <Grid
      container
      width="370px"
      height="364px"
      margin="0 auto"
      alignItems="center"
      justifyContent="center"
      marginTop={5}
      gap={3}
      padding={3}
      borderRadius={1.5}
      border="1px solid rgba(0, 0, 0, 0.25)"
    >
      <img src={login} alt="login" />
      <Button
        type="button"
        onClick={loginWithGoogle}
        variant="outlined"
        fullWidth
        startIcon={<GoogleIcon />}
      >
        Login with Google
      </Button>
    </Grid>
  );
};

export default Login;
